import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import fieldNames from './filenameTemplateFields';


const FolderPathConfiguration = ({
  filenameTemplate,
  addRootFolder,
  removeField,
  edit,
  editable,
  save,
  clear,
}) => {
  const { selectedFolderPathFields, root_folder } = filenameTemplate;

  const fieldPreviews = selectedFolderPathFields.map((field, idx) => {
    const foundField = _.find(fieldNames, { name: field });
    return (
      <span key={`pf2-${field}-${idx}`} className="preview-field">
        { foundField.preview(filenameTemplate) }
      </span>
    );
  });

  const preview = [<span key="pf2-prefix" className="preview-field">{root_folder} / </span>].concat(fieldPreviews);

  const hiddenCls = editable ? '' : 'hidden';

  return (
    <div className="configuration-box folder-path-configuration">
      <div className="right-panel-element">
        <div className="label">
          Folder Path Configuration
          <Button bsSize="xsmall" bsStyle="success" className="edit-btn" onClick={edit}>
            Edit
          </Button>
        </div>
        <div className={`field-container ${hiddenCls}`}>
          <div className="fields">
            { !_.isEmpty(root_folder) && (
              <div className="field selected-field"
                   onClick={() => {
                     addRootFolder({ target: { value: '' } });
                   }}>
                <div>
                  Root Folder: { root_folder[root_folder.length - 1] === '/' ? root_folder : `${root_folder} /` }
                </div>
                <span className="close-marker">X</span>
              </div>
            )}
            { selectedFolderPathFields.map((field, idx) => (
              <div key={`selectedf-${field}-${idx}`}
                   className="field selected-field"
                   onClick={() => removeField(idx)}>
                <div>{field === ' ' ? '[space]' : field}</div>
                <span className="close-marker">X</span>
              </div>
            ))}
          </div>
        </div>
        <div className={`action-buttons ${hiddenCls}`}>
          <div>
            <Button bsSize="small" bsStyle="warning" className="clear-btn" onClick={clear}>Clear</Button>
            <Button bsSize="small" bsStyle="primary" className="save-btn" onClick={save}>Save</Button>
          </div>
        </div>
        <div className={`preview-panel ${hiddenCls}`}>
          <div className="label">Folder Path Preview</div>
          { preview }
        </div>
      </div>
    </div>
  );
};

FolderPathConfiguration.defaultProps = {
  editable: false,
};

FolderPathConfiguration.propTypes = {
  filenameTemplate: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  clear: PropTypes.func.isRequired,
  addRootFolder: PropTypes.func.isRequired,
  removeField: PropTypes.func.isRequired,
  edit: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
};

export default FolderPathConfiguration;



// WEBPACK FOOTER //
// ./src/Integrations/connections/FilenameTemplate/FolderPathConfiguration.jsx